import React, { createContext, useContext, useState } from "react";

const ClientContext = createContext();

export const ClientProvider = ({ children }) => {
  const [clientInspectionView, setClientInspection] = useState(false);
  const [clientContaractView, setClientContaract] = useState(false);
  const [clientEquipmentsView, setClientEquipments] = useState(false);
  const [clientServiceView, setClientService] = useState(false);
  const [clientInvoiceView, setClientInvoice] = useState(false);
  const [isClientViewUpdate, setIsClientViewUpdate] = useState(false);
  

  const updateClientContaract = (newCurrency) => {
    setClientContaract(newCurrency);
  };

  const updateClientInspection = (newCurrency) => {
    setClientInspection(newCurrency);
  };
  const updateClientEquipments = (newCurrency) => {
    setClientEquipments(newCurrency);
  };

  const updateClientService = (newCurrency) => {
    setClientService(newCurrency);
  };

  const updateClientInvoice = (newCurrency) => {
    setClientInvoice(newCurrency);
  };

    const updateIsClientViewUpdate = (newCurrency) => {
    setIsClientViewUpdate(newCurrency);
  };

  return (
    <ClientContext.Provider
      value={{
        clientInspectionView,
        updateClientInspection,
        clientEquipmentsView,
        updateClientEquipments,
        clientServiceView,
        updateClientService,
        clientInvoiceView,
        updateClientInvoice,
        clientContaractView,
        updateClientContaract,
        isClientViewUpdate,
        updateIsClientViewUpdate
      }}
    >
      {children}
    </ClientContext.Provider>
  );
};

export const useClients = () => {
  const context = useContext(ClientContext);
  if (!context) {
    throw new Error("useStandard must be used within a CurrencyContext");
  }
  return context;
};
